import { render, staticRenderFns } from "./TaskManagerSingle.vue?vue&type=template&id=4955eec7&"
import script from "./TaskManagerSingle.vue?vue&type=script&lang=js&"
export * from "./TaskManagerSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports